module.exports = __webpack_public_path__ + "static/media/1-5-4.8f5604b0.png";